export const statutCE = [
  {
    value: "7951378f-cd92-43ea-9b50-5f1713384a4a",
    id: "7951378f-cd92-43ea-9b50-5f1713384a4a",
    label: "A rédiger",
  },
  {
    value: "b63dea2e-4f99-4d43-977d-02de1d7e2ec0",
    id: "b63dea2e-4f99-4d43-977d-02de1d7e2ec0",
    label: "Envoyer/Attente signature",
  },
  {
    value: "2b6e85dd-f867-46a6-8d50-d88895bcb5bc",
    id: "2b6e85dd-f867-46a6-8d50-d88895bcb5bc",
    label: "Signé",
  },
]

export const statutFacturation = [
  {
    value: "3d4ea647-2316-4363-a172-7adb02a40763",
    id: "3d4ea647-2316-4363-a172-7adb02a40763",
    label: "Facture envoyée",
  },
  {
    value: "1d158f50-65a1-40b6-bd0c-c49ea96653aa",
    id: "1d158f50-65a1-40b6-bd0c-c49ea96653aa",
    label: "Facture payée",
  },
]

export const statutPL = [
  {
    value: "fe8e4cae-7f7f-49e5-8075-4793db75c0ab",
    id: "fe8e4cae-7f7f-49e5-8075-4793db75c0ab",
    label: "A créer",
  },
  {
    value: "e5fdf5b5-95cf-41fe-9f08-6873d955ddef",
    id: "e5fdf5b5-95cf-41fe-9f08-6873d955ddef",
    label: "Créée",
  },
  {
    value: "4bfc7db4-e303-4b03-a2aa-80a493b48e68",
    id: "4bfc7db4-e303-4b03-a2aa-80a493b48e68",
    label: "Transmise",
  },
  {
    value: "bee08b32-4ce7-4947-ac3f-2a2a0711842d",
    id: "bee08b32-4ce7-4947-ac3f-2a2a0711842d",
    label: "Clôturé",
  },
]

export const statutDcsPpi = [
  {
    value: "49b5be3e-a9d7-4ad0-8c5f-3e51534ee67a",
    id: "49b5be3e-a9d7-4ad0-8c5f-3e51534ee67a",
    label: "À faire",
  },
  {
    value: "d3720cad-edac-4361-8ce9-19b0c77371cd",
    id: "d3720cad-edac-4361-8ce9-19b0c77371cd",
    label: "Analyse en cours",
  },
  {
    value: "5eaa849c-0d2e-4d0f-a989-89017e00a1eb",
    id: "5eaa849c-0d2e-4d0f-a989-89017e00a1eb",
    label: "En vérification",
  },
  {
    value: "291df929-08a3-43c2-9fe6-ae965534870a",
    id: "291df929-08a3-43c2-9fe6-ae965534870a",
    label: "En approbation/Signature",
  },
  {
    value: "675aa62c-abb7-483b-ab6e-7d04cbb968bf",
    id: "675aa62c-abb7-483b-ab6e-7d04cbb968bf",
    label: "Terminé/Transmis",
  },
  {
    value: "3d2947f8-da0d-4940-89c6-a99a825b371f",
    id: "3d2947f8-da0d-4940-89c6-a99a825b371f",
    label: "En attente/Pause",
  },
  {
    value: "6b158039-9cba-4c2b-917f-f2299c2ed7e3",
    id: "6b158039-9cba-4c2b-917f-f2299c2ed7e3",
    label: "Annulé",
  },
]

export const statutAt = [
  {
    value: "favorable",
    id: "favorable",
    label: "Favorable",
  },
  {
    value: "unfavorable",
    id: "unfavorable",
    label: "Défavorable",
  },
]

export const statutInfrapole = [
  {
    value: "0c07d08b-3054-45c5-a6ee-4f4a91850bbe",
    id: "0c07d08b-3054-45c5-a6ee-4f4a91850bbe",
    label: "À completer",
  },
  {
    value: "73249d45-8f8d-4e71-97d1-c536393eb586",
    id: "73249d45-8f8d-4e71-97d1-c536393eb586",
    label: "Complétée",
  },
]

export const statutTiers = [
  {
    value: "3d98bbc7-076f-49eb-ba5a-ab0972837939",
    id: "3d98bbc7-076f-49eb-ba5a-ab0972837939",
    label: "À compléter",
  },
  {
    value: "87984956-c097-443e-8597-0ebd33de6cf9",
    id: "87984956-c097-443e-8597-0ebd33de6cf9",
    label: "Attente retour SNCF R",
  },
  {
    value: "5e5df245-ff76-4527-81a2-eb83c2a93205",
    id: "5e5df245-ff76-4527-81a2-eb83c2a93205",
    label: "À signer",
  },
  {
    value: "33f36324-df5c-4b0e-8658-4d1985a49912",
    id: "33f36324-df5c-4b0e-8658-4d1985a49912",
    label: "Signée",
  },
]

export const statutPpiLevel = [
  {
    value: "1f7f2196-1d93-44ce-a489-7b30313b1288",
    id: "1f7f2196-1d93-44ce-a489-7b30313b1288",
    label: "NSF à vérifier",
  },
  {
    value: "72df94f9-d08d-4d7a-be3c-c6739504404d",
    id: "72df94f9-d08d-4d7a-be3c-c6739504404d",
    label: "FO en cours",
  },
  {
    value: "1b53a13f-f81d-41d5-9ebc-c0f76840167e",
    id: "1b53a13f-f81d-41d5-9ebc-c0f76840167e",
    label: "FO en vérification",
  },
  {
    value: "0c07d08b-3054-45c5-a6ee-4f4a91850bbe",
    id: "1b53a13f-f81d-41d5-9ebc-c0f76840167e",
    label: "FO terminée",
  },
  {
    value: "f9fca029-3a75-4eec-82e2-92badda51522",
    id: "f9fca029-3a75-4eec-82e2-92badda51522",
    label: "En attente/Pause",
  },
  {
    value: "01ab2c4c-683f-4ad3-874e-7c932fe88712",
    id: "01ab2c4c-683f-4ad3-874e-7c932fe88712",
    label: "Annulée",
  },
  {
    value: "ad8bdf52-5263-420d-ab96-ab1a5f919b82",
    id: "ad8bdf52-5263-420d-ab96-ab1a5f919b82",
    label: "À signer",
  },
]

export const statutFo = [
  {
    value: "favorable",
    id: "favorable",
    label: "Favorable",
  },
  {
    value: "unfavorable",
    id: "unfavorable",
    label: "Défavorable",
  },
]

export const statutIcVicIcp = [
  {
    value: "to_schedule",
    id: "to_schedule",
    label: "A programmer",
  },
  {
    value: "done",
    id: "done",
    label: "Réalisé",
  },
  {
    "value": "not_concerned",
    "id": "not_concerned",
    "label": "Non concerné",
  }
]

export const listWorkingRange = [
  {
    value: "morning",
    id: "813ae484-0ec3-4ed2-94d4-510caaa8ec82",
    label: "Matin",
  },
  {
    value: "afternoon",
    id: "a993ee33-30c6-4fc0-acf0-e6d357f2f644",
    label: "Après-midi",
  },
  {
    value: "night",
    id: "7ab07fc2-ded6-4a4a-9920-07fcb3d44b1c",
    label: "Nuit",
  },
]

export const getListDevisExcelFields = (plType) => [
  {
    field: "N° PL",
    name: `number_${plType}`,
    stepName: "suivi_comptable",
  },
  {
    field: "MONTANT PPI",
    name: `montant_ppi_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "MONTANT MSF",
    name: `montant_msf_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "MONTANT IP",
    name: `montant_ip_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "COUT SUPPORT",
    name: `cout_support_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "MARGE",
    name: `marge_1_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "MARGE ",
    name: `marge_1_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  },
  {
    field: "MONTANT TOTAL",
    name: `montant_total_${plType}`,
    stepName: "suivi_comptable",
    format: "monetary",
  }
]

export const listTypeDocumentTiers = [
  {
    value: "dcs",
    label: "DCS",
  },
  {
    value: "contrat_etude",
    label: "Contrat Étude",
  },
  {
    value: "analyse_technique",
    label: "Analyse Technique",
  },
  {
    value: "nsf",
    label: "NSF",
  },
  {
    value: "fo",
    label: "FO",
  },
  {
    value: "contrat_travaux",
    label: "Contrat Travaux",
  },
  {
    value: "pc_get_divers",
    label: "PC-GET-Divers",
  }
]

export const listTypeDocumentInterne = [
  {
    value: "contrat_etude",
    label: "Contrat Étude",
  },
  {
    value: "analyse_technique",
    label: "Analyse Technique",
  },
  {
    value: "nsf",
    label: "NSF",
  },
  {
    value: "fo",
    label: "FO",
  },
  {
    value: "contrat_travaux",
    label: "Contrat Travaux",
  },
  {
    value: "pc_get_divers",
    label: "PC-GET-Divers",
  },
  {
    value: "rex",
    label: "Rex",
  },
]

export const listDayToDay = [
  {
    value: "LuMa",
    label: "LuMa",
  },
  {
    value: "MaMe",
    label: "MaMe",
  },
  {
    value: "MeJe",
    label: "MeJe",
  },
  {
    value: "JeVe",
    label: "JeVe",
  },
  {
    value: "VeSa",
    label: "VeSa",
  },
  {
    value: "SaDi",
    label: "SaDi",
  },
  {
    value: "DiLu",
    label: "DiLu",
  },
]

export const getPhaseLength = (worksDecrees) => ([
  {
    phase: "etude_impact",
    index: 0,
    phaseLength: 6,
  },
  {
    phase: "validation_dcs",
    index: 1,
    phaseLength: 3,
  },
  {
    phase: "validation_nsf",
    index: 2,
    phaseLength: 6,
  },
  {
    phase: "realisation_travaux",
    index: 3,
    phaseLength: worksDecrees == 94 ? 8 : 5,
  },
])

export const stepInfos = [
  // Phase 1 : Étude d’impact
  {
    value: "date_creation_case",
    label: "Création de l’affaire",
    index: 0,
  },
  {
    value: "date_reception_dossier_etude_impact",
    label: "Réception dossier étude d’impact",
    index: 0,
  },
  {
    value: "need_msf",
    label: "Étude d’impact",
    index: 0,
  },
  {
    value: "dcs_complet_reception_date",
    label: "Réception du DCS complet",
    index: 1,
  },
  {
    value: "date_ce_achievement",
    label: "Réalisation du CE",
    index: 2,
  },
  {
    value: "date_study_signed",
    label: "CE à signer par le tiers",
    index: 3,
  },
  {
    value: "date_pl_astre",
    label: "Demande d'étude PPI",
    index: 4,
  },
  // Phase 2 : Validation du DCS
  {
    value: "dcs_reception_date",
    label: "Réception du DCS",
    index: 0,
  },
  {
    value: "statut_at",
    label: "DCS en étude",
    index: 0,
  },
  {
    value: "statut_at_favorable",
    label: "Résultat AT favorable",
    index: 0,
  },
  {
    value: "dcs_complementaire_reception_date",
    label: "Attente éléments complémentaires",
    index: 1,
  },
  {
    value: "statut_fo_phase_2",
    label: "DCS en étude complémentaire",
    index: 2,
  },
  {
    value: "statut_favorable_phase_2",
    label: "Résultat AT ou FO favorable",
    index: 2,
  },
  // Phase 3 : Validation de la NSF
  {
    value: "date_msf_issue",
    label: "NSF initiée",
    index: 0,
  },
  {
    value: "date_infra_completion",
    label: "NSF à compléter par l'Infrapôle",
    index: 0,
  },
  {
    value: "date_tiers_completion",
    label: "NSF à compléter par le tiers",
    index: 1,
  },
  {
    value: "statut_fo",
    label: "FO à rédiger",
    index: 2,
  },
  {
    value: "statut_fo_unfavorable",
    label: "NSF à reprendre par le tiers",
    index: 3,
  },
  {
    value: "nsf_index",
    label: "FO à rédiger",
    index: 4,
  },
  {
    value: "validation_nsf",
    label: "NSF à valider par l'Infrapôle",
    index: 5,
  },
  // Phase 4 : Réalisation travaux
  {
    value: "planning_validation",
    label: "Planning à définir et valider",
    index: 0,
  },
  {
    value: "date_ct_achievement",
    label: "Réalisation du CT",
    index: 1,
  },
  {
    value: "date_CT_signed",
    label: "CT à signer",
    index: 2,
  },
  {
    value: "statut_IC",
    label: "IC à compléter",
  },
  {
    value: "statut_VIC",
    label: "VIC à compléter",
  },
  {
    value: "date_csf_validation",
    label: "CSF à compléter par l'Infrapôle",
  },
  {
    value: "date_isf_validation",
    label: "ISF à compléter par l'Infrapôle",
  },
  {
    value: "statut_ICP",
    label: "ICP à compléter",
  },
  {
    value: "date_works_end",
    label: "Réalisation des travaux",
  },
]

export const getTravauxIndex = (worksDecrees, step) => {
  switch (step) {
    case "statut_IC":
      return worksDecrees == 94 ? 3 : 2
    case "statut_VIC":
      return worksDecrees == 94 ? 4 : 2
    case "date_csf_validation":
      return worksDecrees == 94 ? 5 : 2
    case "date_isf_validation":
      return worksDecrees == 94 ? 6 : 2
    case "statut_ICP":
      return worksDecrees == 94 ? 7 : 3
    case "date_works_end":
      return worksDecrees == 94 ? 7 : 4
  }
}